// TODO : will migrate to the ts having some issue with the types
import { createSlice } from '@reduxjs/toolkit';
import {
  disconnectWhatsAppBusinessAccount,
  saveWhatsappConnectionResponse,
  resetWhatsAppErrorMessages,
  verifyWhatsAppNumber,
  resetWSSBusinessData,
  resetShouldOpenOTPForm,
} from 'redux/actions/whatsappSelfService';
import { whatsAppNumberTypes } from 'appConstants';

const initialState = {
  isDisconnected: false,
  fatalErrorMessage: '',
  shouldOpenOTPForm: false,
};

const whatsAppSelfServiceSlice = createSlice({
  name: 'whatsappSelfService',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(resetWhatsAppErrorMessages, (state) => {
      state.fatalErrorMessage = '';
    });
    builder.addCase(disconnectWhatsAppBusinessAccount.pending, (state) => {
      state.isDisconnected = false;
    });
    builder.addCase(disconnectWhatsAppBusinessAccount.fulfilled, (state) => {
      state.isDisconnected = true;
    });
    builder.addCase(disconnectWhatsAppBusinessAccount.rejected, (state, action) => {
      state.isDisconnected = false;
      state.fatalErrorMessage = action.payload.apiResult.message;
    });
    builder.addCase(resetWSSBusinessData.rejected, (state, action) => {
      state.fatalErrorMessage = action.payload.apiResult.message;
    });
    builder.addCase(saveWhatsappConnectionResponse.rejected, (state, action) => {
      state.fatalErrorMessage = action.payload.message ?? '';
    });
    builder.addCase(saveWhatsappConnectionResponse.fulfilled, (state, action) => {
      const { resourceLinkList } = action.payload.user;
      const { whatsAppBusinessAccountId, whatsAppNumberType } =
        resourceLinkList.find((item) => item.name === 'TextRecruit') || {};

      if (
        whatsAppBusinessAccountId &&
        whatsAppNumberType === whatsAppNumberTypes.NON_TWILIO_PHONE_NUMBER
      ) {
        state.shouldOpenOTPForm = true;
      }
    });
    builder.addCase(verifyWhatsAppNumber.rejected, (state, action) => {
      state.fatalErrorMessage = action.payload.apiResult.message;
    });
    builder.addCase(resetShouldOpenOTPForm, (state) => {
      state.shouldOpenOTPForm = false;
    });
  },
});
export default whatsAppSelfServiceSlice;
